import Table from "@/components/Table.vue";
import Excel from "@/components/Excel.vue";
import Vue from "vue";

export default {
  name: "Data",

  components: {
    Table,
    Excel,
  },

  data: () => ({
    access: false,
    passwordValue: "df5h!",
    password: "",
    passwordRules: [
        v => !!v || 'Password is required',
      ],    
    headers: [
      {
        text: "First Name",
        align: "start",
        sortable: false,
        value: "firstName",
      },
      {
        text: "Last Name",
        align: "start",
        sortable: false,
        value: "lastName",
      },
      {
        text: "Company",
        align: "start",
        sortable: false,
        value: "company",
      },
      {
        text: "Question",
        align: "start",
        sortable: false,
        cellClass: "col-question",
        value: "question",
      },
      {
        text: "Agree",
        align: "center",
        sortable: true,
        value: "agree",
      },
      {
        text: "Timestamp",
        align: "end",
        sortable: true,
        value: "timestamp",
      },
    ],
    items: [],
  }),
  methods: {
    onLogin() {
      console.warn(this.password);

      if(this.password == this.passwordValue) {
          this.access = true;
      }
    },
    getData() {
      Vue.axios
        .get(
          "https://www.virtualexhibition.o-ran.org/api/Form/GetSummitQuestionaryData"
          // "http://localhost:5000/api/Form/GetSummitQuestionaryData",
        )
        .then((response) => {
          // console.warn(response);

          this.items = response.data;
        })
        .catch(() => {});
    },

    getFields() {
      return {
        FirstName: "firstName",
        LastName: "lastName",
        Company: "company",
        Question: "question",
        Agree: "agree",
        Timestamp: "timestamp",
      };
    },
  },
  created() {
    this.getData();
  },
};
